import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, ListItem } from 'material-ui';

import NestedItem from './nestedItem';

const { object, array } = PropTypes;

const ListFilter = ({ filterKey, clearListFilter, onListFilterChange, title, list }) => {
  const anyValueSelected = list.some(obj => obj.checked);
  return (
    <ListItem
      primaryText={title}
      insetChildren
      leftCheckbox={
        <Checkbox
          disabled={!anyValueSelected}
          checked={anyValueSelected}
          onCheck={() => clearListFilter({ filterKey })}
        />
      }
      primaryTogglesNestedList
      nestedItems={
        list.map((obj, i) => (<ListItem
          key={i}
          leftCheckbox={<Checkbox
            checked={Boolean(obj.checked)}
            onCheck={(_, checked) => onListFilterChange({ filterKey, listIndex: i, checked })}
          />}
          primaryText={obj.title}
        />))
      }
    />
  );
};

ListFilter.propTypes = {
  filter: object,
  selectedValue: array,
};

export default ListFilter;



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/components/dashboardFilter/listFilter.jsx